const adminEditRouters = [
  {
    path: "/admin/sheet/edit",
    component: () => import("@/views/Backend/AdminEdit/Sheet"),
    name: "admin-edit-sheet",
    meta: { hideNav: true },
    children: [
      {
        path: "info",
        component: () => import("@/views/Backend/AdminEdit/Sheet/Info"),
        name: "edit-sheet-info",
        meta: { hideNav: true }
      },
      {
        path: "field",
        component: () => import("@/views/Backend/AdminEdit/Sheet/Field"),
        name: "edit-sheet-field",
        meta: { hideNav: true }
      },
      {
        path: "field-rules",
        component: () => import("@/views/Backend/AdminEdit/Sheet/FieldRules"),
        name: "edit-sheet-field-rules",
        meta: { hideNav: true }
      },
      {
        path: "custom-button",
        component: () => import("@/views/Backend/AdminEdit/Sheet/CustomButton"),
        name: "edit-sheet-custom-button",
        meta: { hideNav: true }
      },
      {
        path: "view",
        component: () => import("@/views/Backend/AdminEdit/Sheet/View"),
        name: "edit-sheet-view",
        meta: { hideNav: true }
      }
    ]
  },
  {
    path: "/admin/workflow/edit",
    component: () => import("@/views/Backend/AdminEdit/Workflow"),
    name: "admin-edit-workflow",
    meta: { hideNav: true }
  },
  {
    path: "/admin/print-template/edit",
    component: () => import("@/views/Backend/AdminEdit/PrintTemplate"),
    name: "admin-edit-print-template",
    meta: { hideNav: true }
  }
]

export default adminEditRouters
